<template>
  <div v-if="preloader">
    <template>
      <div class="d-flex align-center justify-center flex-column" style="height: 100vh;">
          <bubble-loader/>
      </div>
    </template>
  </div>

  <div v-else>
    <v-card
      height="64px"
      width="100%"
      class="background ml-4 mr-6 my-0 px-4 transparent elevation-0 d-flex flex-row justify-space-between align-center"
      style="
        position: fixed;
        z-index: 200;
        top: 0;
        width: 98%;
        padding-top: 16px;
      "
    >
      <v-card-title class="ml-0">
        <p class="breadcrumb-text">Assessments</p>
        <span><v-icon class="breadcrumb-arrow">mdi-chevron-down</v-icon></span>
      </v-card-title>
      <UserNavMenu/>
    </v-card>
    <div fluid class="pad px-3 background">
      <v-dialog max-width="880px" class="cdz" v-model="updateAssessmentDialog" center>
        <v-form ref="updateForm" lazy-validation @submit.prevent="assessmentUpdate">
          <v-card>
            <v-card-title class="primary mb-2 pl-7">
              Update Assessment
            </v-card-title>

            <v-card-title>
              <v-col>
                <v-text-field outlined class="rounded-xl" v-model="currentSelectedAssessment.assessmentName"
                  label="Assessment Name*" :rules="[v => !!v || 'Assessment Name is required']" required>
                </v-text-field>

                <div class="text-body-1 my-2">Assessment Description*</div>

                <ckeditor :config="editorConfig" v-model="currentSelectedAssessment.assessmentDescription"
                  class="m-ckeditor" @ready="onEditorReady" :name="'ckeditor'">
                </ckeditor>
                <!-- <span v-if="ckeditorError" class="mt-2" type="error"> Assessment Description is required </span> -->
              </v-col>
            </v-card-title>

            <v-card-actions class="px-6 pb-6">
              <small>*All fields are mandatory</small>
              <v-spacer></v-spacer>
              <v-btn rounded outlined width="102px" height="48px"
                @click="() => { updateAssessmentDialog = false; }"
                class="accent--text pa-4">
                Cancel
              </v-btn>

              <v-btn width="102px" height="48px" rounded
                @click="validateAssessmentUpdateForm" class="accent pa-4"
                :loading="updateAssessmentDialogLoading"
              >
                Update
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-form>
      </v-dialog>

      <v-dialog v-model="deleteAssessmentDialog" max-width="366px" class="cdz" persistent>
        <v-card fluid>
          <v-container fluid class="pa-0">
            <v-card-text class="text-center">
              <v-icon size="70" class="pt-4">mdi-trash-can-outline</v-icon>
              <p class="text-h5 pt-4 pb-0">Delete Assessment</p>
              <p class="text-disabled grey--text text-subtitle-1 mb-4"
                color="rgba(0, 0, 0, 0.6)" disabled>
                This action will delete the Assessment.
              </p>

              <div class="d-flex justify-space-between" fluid>
                <v-btn depressed class="btn outline-btn" rounded large
                  width="157px" @click="deleteAssessmentDialog = false">
                  CANCEL
                </v-btn>

                <v-btn class="btn primary-btn" depressed large width="157px" rounded
                  @click="deleteAssessment(currentSelectedAssessment.id)">
                  DELETE
                </v-btn
                >
              </div>
            </v-card-text>
          </v-container>
        </v-card>
      </v-dialog>

      <v-dialog v-model="deleteSuccessDialog" class="cdz" max-width="366px" persistent>
        <v-card>
          <v-container fluid class="pa-8">
            <v-card-text class="text-center">
              <v-icon color="#228B22" size="96"
                >mdi-check-circle-outline</v-icon
              >
              <p class="text-h5 font-weight-bold py-4">Assessment Deleted</p>
              <div class="d-flex justify-center">
                <v-btn
                  class="primary-btn btn"
                  large
                  width="157px"
                  rounded
                  @click="deleteSuccessDialog = false"
                  >Ok</v-btn
                >
              </div>
            </v-card-text>
          </v-container>
        </v-card>
      </v-dialog>

      <!-- Filter Dialog -->
    <v-dialog v-model="filterDialog" class="cdz" max-width="570px" style="z-index:1000 !important">
      <v-card width="700px" height="100vh" class="filterDialogClass">
        <div class="d-flex justify-space-between pt-2 px-4">
          <div class="pl-0 mb-2 text-body1 font-weight-bold grey--text">
            Filter
          </div>
                  
          <div class="clear-filter-btn" @click="clearFilter">
            CLEAR FILTER
          </div>
        </div>
        <v-tabs vertical>   
          <div class="ml-3 mt-4 mr-4 filterLine">
            
            <v-tab key="languages" class="black--text justify-start" active-class="activeTab">
              <span>Languages</span>
              <span class="ml-1" v-if="selectedLanguageFilter.length > 0">
                ({{ selectedLanguageFilter.length }})</span>
            </v-tab>
            <v-tab key="coreSkillsSubject" class="black--text justify-start" active-class="activeTab" v-if="subjectOptions.length > 0">
              <span>Subjects</span>
              <span class="ml-1" v-if="selectedSubjectFilter.length > 0">
                ({{ selectedSubjectFilter.length }})</span>
            </v-tab>

              <v-tab key="skill" class="black--text justify-start" active-class="activeTab">
              <span>Skill</span>
              <span class="ml-1" v-if="selectedSkillFilter.length > 0">
              ({{ selectedSkillFilter.length }})</span>
            </v-tab>
            <v-tab key="timerType" class="black--text justify-start" active-class="activeTab">
              <span>Timer Type</span>
              <span class="ml-1" v-if="selectedTimerFilter.length > 0">
              ({{selectedTimerFilter.length}})</span>
            </v-tab>
            <v-tab key="userType" class="black--text justify-start" active-class="activeTab">
              <span>User Type</span>
              <span class="ml-1" v-if="selectedUserFilter.length > 0">
              ({{selectedUserFilter.length}})</span>
            </v-tab>
            <v-tab key="category" class="black--text justify-start" active-class="activeTab">
              <span>Category</span>
              <span class="ml-1" v-if="selectedUserFilter.length > 0">
              ({{selectedCategoryFilter.length}})</span>
            </v-tab>
            <v-tab key="level" class="black--text justify-start" active-class="activeTab">
              <span>Level</span>
              <span class="ml-1" v-if="selectedLevelFilter.length > 0">
              ({{selectedLevelFilter.length}})</span>
            </v-tab>
            <v-tab key="grade" class="black--text justify-start" active-class="activeTab">
              <span>Grade</span>
              <span class="ml-1" v-if="selectedGradeFilter.length > 0">
              ({{selectedGradeFilter.length}})</span>
            </v-tab>
            <v-tab key="section" class="black--text justify-start" active-class="activeTab">
              <span>Section</span>
              <span class="ml-1" v-if="selectedSectionFilter.length > 0">
              ({{selectedSectionFilter.length}})</span>
            </v-tab>
            <v-tab key="creationDateAndTime" class="black--text justify-start" active-class="activeTab">
              <span>Creation Date & Time</span>
              <span class="ml-1" v-if="selectedCreationDateAndTimeFilter">
              (1)</span>
            </v-tab>
          
          </div>
          <!-- <v-tab-item key="grades">
            <v-card>
              <v-card-text>
                <v-chip-group v-model="selectedGradeFilter" active-class="active-chip" column :multiple="true">
                  <v-chip v-for="(grade,index) in gradeOptions" 
                  :key="grade"
                  :value="grade"
                  elevated>
                    {{grade}}
                  </v-chip>
                </v-chip-group>
              </v-card-text>
            </v-card>
          </v-tab-item> -->

          <v-tab-item key="languages">
            <v-card flat class="school-filter">
              <v-card-text>
                <v-chip-group v-model="selectedLanguageFilter" active-class="active-chip" column :multiple="true">
                  <v-chip v-for="(language,index) in languageOptions" 
                  :key="language"
                  :value="language"
                  elevated>
                    {{language}}
                  </v-chip>
                </v-chip-group>
              </v-card-text>
            </v-card>
          </v-tab-item>

          <v-tab-item key="coreSkillsSubject" v-if="subjectOptions.length > 0">
            <v-card flat class="school-filter">
              <v-card-text>
                <v-chip-group v-model="selectedSubjectFilter" active-class="active-chip" column :multiple="true">
                  <v-chip v-for="(subject,index) in subjectOptions" 
                  :key="subject"
                  :value="subject"
                  elevated>
                    {{subject}}
                  </v-chip>
                </v-chip-group>
              </v-card-text>
            </v-card>
          </v-tab-item>
          <v-tab-item key="skill">
            <v-card flat class="school-filter">
              <v-card-text>
                <v-chip-group v-model="selectedSkillFilter" active-class="active-chip" column :multiple="true">
                  <v-chip v-for="(skill,index) in skillOptions" 
                  :key="skill"
                  :value="skill"
                  elevated>
                    {{skill}}
                  </v-chip>
                </v-chip-group>
              </v-card-text>
            </v-card>
          </v-tab-item>
          
          <v-tab-item key="timerType">
            <v-card flat class="school-filter">
              <v-card-text>
                <v-chip-group v-model="selectedTimerFilter" active-class="active-chip" column :multiple="true">
                  <v-chip v-for="(timerType,index) in timerTypeOptions" 
                  :key="timerType"
                  :value="timerType"
                  elevated>
                    {{timerType}}
                  </v-chip>
                </v-chip-group>
              </v-card-text>
            </v-card>
          </v-tab-item>
          <v-tab-item key="userType">
            <v-card flat class="school-filter">
              <v-card-text>
                <v-chip-group v-model="selectedUserFilter" active-class="active-chip" column :multiple="true">
                  <v-chip v-for="(userType,index) in userTypeOptions" 
                  :key="userType"
                  :value="userType"
                  elevated>
                    {{userType}}
                  </v-chip>
                </v-chip-group>
              </v-card-text>
            </v-card>
          </v-tab-item>
          <v-tab-item key="category">
            <v-card flat class="school-filter">
              <v-card-text>
                <v-chip-group v-model="selectedCategoryFilter" active-class="active-chip" column :multiple="true">
                  <v-chip v-for="(value,category) in categoryOptions" 
                  :key="category"
                  :value="category"
                  elevated>
                    {{category}}
                  </v-chip>
                </v-chip-group>
              </v-card-text>
            </v-card>
          </v-tab-item>
          <v-tab-item key="level">
            <v-card v-if="selectedCategoryFilter.length <= 0" flat class="school-filter">
                <v-card-text class="d-flex justify-center">
                  Please Select Category First
                </v-card-text>
            </v-card>
            <v-card v-else flat class="school-filter">
              <v-card-text>
                <v-chip-group v-model="selectedLevelFilter" active-class="active-chip" column :multiple="true">
                  <v-chip v-for="(level,index) in levelOptions" 
                  :key="level"
                  :value="level"
                  elevated>
                    {{level}}
                  </v-chip>
                </v-chip-group>
              </v-card-text>
            </v-card>
          </v-tab-item>
          <v-tab-item key="grade">
            <v-card v-if="selectedCategoryFilter.length <= 0" flat class="school-filter">
              <v-card-text class="d-flex justify-center">
                  Please Select Category First
              </v-card-text>
            </v-card>
            <v-card v-else flat class="school-filter">
              <v-card-text>
                <v-chip-group v-model="selectedGradeFilter" active-class="active-chip" column :multiple="true">
                  <v-chip v-for="(grade,index) in gradeOptions" 
                  :key="grade"
                  :value="grade"
                  elevated>
                    {{grade}}
                  </v-chip>
                </v-chip-group>
              </v-card-text>
            </v-card>
          </v-tab-item>
          <v-tab-item key="section">
            <v-card v-if="selectedCategoryFilter.length <= 0" flat class="school-filter">
                <v-card-text class="d-flex justify-center">
                  Please Select Category First
                </v-card-text>
            </v-card>
            <v-card v-else flat class="school-filter">
              <v-card-text>
                <v-chip-group v-model="selectedSectionFilter" active-class="active-chip" column :multiple="true">
                  <v-chip v-for="(section,index) in sectionOptions" 
                  :key="section"
                  :value="section"
                  elevated>
                    {{section}}
                  </v-chip>
                </v-chip-group>
              </v-card-text>
            </v-card>
          </v-tab-item>

          <v-tab-item key="creationDateAndTime">
            <v-card class="my-container school-filter" flat>
              <v-card-text class="pt-0">
                <v-chip-group v-model="selectedCreationDateAndTimeFilter" active-class="active-chip" column :multiple="false">
                  <v-chip v-for="(creationDateAndTime,index) in creationDateAndTimeOptions" :key="index" :value="creationDateAndTime.value" elevated>
                    {{creationDateAndTime.label}}
                  </v-chip>
                  <v-menu v-model="menu" :close-on-content-click="false" transition="scale-transition" offset-y>
                    <template v-slot:activator="{ on, attrs }">
                      <v-chip v-bind="attrs" v-on="on" elevated active-class="active-chip">
                        Custom Dates 
                      </v-chip>
                    </template>
                    <v-card>
                      <v-card-title class="py-1 px-4">Select Dates</v-card-title>
                      <v-card-text>
                        <v-row>
                          <v-col>
                            <v-menu ref="menu" v-model="menuStart" :close-on-content-click="false" transition="scale-transition" offset-y min-width="auto">
                              <template v-slot:activator="{ on, attrs }">
                                <v-text-field class="py-0 custom-date-picker"
                                v-bind="attrs" 
                                v-on="on" 
                                label="Start Date" 
                                prepend-icon="mdi-calendar" 
                                v-model="customStartDate"
                                readonly
                                :rules="[v => !!v || 'Start date is required']" 
                                ></v-text-field>
                              </template>
                              <v-date-picker 
                              class="custom-date-picker"
                              v-model="customStartDate" 
                              @input="handleStartDateChange">
                              </v-date-picker>
                            </v-menu>
                          </v-col>
                          <v-col>
                            <v-menu ref="menu" v-model="menuEnd" :close-on-content-click="false" transition="scale-transition" offset-y min-width="auto">
                              <template v-slot:activator="{ on, attrs }">
                                <v-text-field class="py-0 custom-date-picker" 
                                v-bind="attrs" 
                                v-on="on" 
                                label="End Date" 
                                prepend-icon="mdi-calendar" 
                                v-model="customEndDate" 
                                :rules="[v => !!v || 'End date is required']" 
                                :disabled="!customStartDate" 
                                readonly></v-text-field>
                              </template>
                              <v-date-picker 
                              class="custom-date-picker"
                              v-model="customEndDate"
                              :min="customStartDate"
                              @input="menuEnd = false"
                              ></v-date-picker>
                            </v-menu>
                          </v-col>
                        </v-row>
                      </v-card-text>
                      <v-card-actions>
                        <v-btn color="primary" text @click="addCustomDates">Ok</v-btn>
                      </v-card-actions>
                    </v-card>
                  </v-menu>
                </v-chip-group>
              </v-card-text>
            </v-card>
          </v-tab-item>
        </v-tabs>
        <div class="filterDialogButton">
          <v-card-actions class="px-6 pb-0">
            <v-spacer></v-spacer>
            <v-btn
              rounded
              outlined
              class="btn outline-btn pa-4"
              @click="closeFilter"
              >Cancel</v-btn
            >
            <v-btn
              rounded
              class="btn primary-btn pa-4"
              @click="filterAssessments" 
              :loading="filterLoader"
              >Apply</v-btn
            >
          </v-card-actions>
        </div>
      </v-card>                
    </v-dialog>  




    <div class="fixBarCreateCammpaign">
      <v-row>
        <v-col class="d-flex align-center">

        </v-col>
        <v-col cols="4"> </v-col>
      </v-row>

      <!-- assessment user table row with filter btn and color code -->
      <v-row class="my-8 justify-space-between" v-if="showUsers">
        <!-- filter btn and color code -->
        <v-col cols="6" sm="6" md="6" class="d-flex justify-end align-center ma-0 pa-0">
          <v-spacer></v-spacer>

          <v-spacer></v-spacer>

          <v-btn class="btn outline-btn ml-2" rounded>
            <v-icon>mdi-tune</v-icon>Filter</v-btn
          >
        </v-col>
      </v-row>

      <!-- Assessment row and fiter and export btn -->

      <v-row class="justify-space-between mr-5" v-if="!showUsers">
        <v-col class="pl-5" cols="3">
          <div class="text-h6">Assessment</div>
        </v-col>
        <v-col cols="9" class="mt-0">
          <v-row class="justify-end">
            <v-text-field solo label="Search here..." prepend-inner-icon="mdi-magnify" v-model="searchValue"
              hide-details class="search-bar border-button rounded-pill mx-2" dense clearable ref="searchField">
            </v-text-field>

            <v-btn depressed rounded outlined @click="filterDialog=true;" class="btn outline-btn mx-2 pl-4 pr-6">
              <v-icon class="pr-2">mdi-tune</v-icon>
                <span v-if="filterCount > 0">Filter ({{ filterCount }})</span>
                <span v-else >Filter</span></v-btn>
                <v-btn depressed outlined rounded class="btn outline-btn mx-2" :loading="loadingAssessmentsToDownload" @click="downloadAssessment">
                  <v-icon>mdi-import mdi-rotate-90</v-icon>
                </v-btn>
            <!-- <v-btn class="primary mx-2" rounded><v-icon>mdi-export</v-icon>Export</v-btn> -->
            <v-btn
              :disabled="!showUsers && !$store.state.role.assessment.create"
              @click="() => { dialog = true; e1 = 1 ,goToAssessmentCreationForm();}"
              class="btn tertiary-btn ml-2 pl-4 pr-6"
              rounded
              elevation="0"
              ><v-icon class="pr-2">mdi-plus</v-icon>Create
            </v-btn>
          </v-row>
        </v-col>
      </v-row>

      <!-- Live assessment and color code row  -->
      <v-row justify="space-between" class="mr-0 pr-4">
        <v-col class="pl-5 pt-0" cols="8">
          <v-chip-group mandatory v-model="currentSelectedAssessmentStatus" class="">
            <v-chip :value=0 @click="preloader=true;assessments=[];fetchStaticAssessmentCounts();fetchAssessment('PUBLISHED')" class="mr-4" :color="currentSelectedAssessmentStatus == 0? 'active-chip' : ''"> Published ({{assessmentCounts.PUBLISHED || 0}}) </v-chip>
            <!-- <v-chip @click="preloader=true;assessments=[];fetchStaticAssessmentCounts();fetchAssessment('DRAFT')" class="mr-4" :color="currentSelectedAssessmentStatus == 1?  'active-chip' : ''"> Draft ({{assessmentCounts.DRAFT || 0}}) </v-chip> -->
            <!-- <v-chip disabled class="mr-4"> Sent for approval (0) </v-chip>
            <v-chip disabled class="mr-4"> Rejected (0) </v-chip> -->
            <v-chip :value=2 @click="preloader=true;assessments=[];fetchStaticAssessmentCounts();fetchAssessment('LIVE')" class="mr-4" :color="currentSelectedAssessmentStatus == 2?  'active-chip' : ''"> Live ({{assessmentCounts.LIVE || 0}}) </v-chip>
          </v-chip-group>
        </v-col>
        <v-col class="d-flex justify-end align-center">
          <v-btn text color="#3F41D1" @click="showReportedQuestions">View Reported Questions</v-btn>
        </v-col>
      </v-row>
    </div>

      <!------------------------------------------ Assessment card here---------------------------- -->
      <div v-if="assessmentLoader">
        <template>
          <v-dialog v-model="assessmentLoader" hide-overlay persistent width="300">
            <bubble-loader/>
          </v-dialog>
        </template>
      </div>
      <div v-else> 
        <v-container class="stepper-content-height" style="margin-top: 132px!important;"fluid v-if="!showUsers" id="myScroll">
          <v-row v-if="assessments.length">
            <v-col class="pa-2"
              v-for="assessment in assessments" :key="assessment.id" cols="12" sm="4" md="4" lg="4" xl="3">
              <v-card
                height="100%"
                class="pa-4 cardBorder rounded-lg d-flex flex-column mr-3"
                style="font-size: 14px;  cursor: 'pointer'"
                @click=" goToViewAssessment(assessment)"            
              >
                <v-card-title class="pa-0 cursor">{{ assessment.name }}</v-card-title>
                
                <div class="d-flex flex-row justify-space-between">
                  <div class="d-flex flex-column justify-space-between">
                    <span class="card-sub-text" style="font-size: 11px">{{ assessment.level}} : {{ Array.isArray(assessment.grade) ? assessment.grade?.join(", ") : assessment.grade }}</span>
                    <span class="font-weight-bold">{{ assessment.assessmentName}} </span>
                    
                  </div>
                  <template>
                    <div class="assessmentIconColor">
                      <v-menu offset-y left transition="scale-transition">
                        <template v-slot:activator="{ on, attrs }">
                          <v-icon style="font-size: 29px !important;" class="p-0" v-bind="attrs" v-on="on">
                            mdi-dots-vertical
                          </v-icon>
                        </template>
                        <v-list>
                          <v-list-item @click="editAssessment(assessment)" style="cursor: pointer;" v-if="assessment.isEditable" :disabled="!$store.state.role.assessment.update">
                            <v-list-item-title>Edit</v-list-item-title>
                          </v-list-item>
                          <v-list-item v-if="assessment.isQuestionUploaded" @click="initiateMockTest(assessment.id)" style="cursor: pointer;">
                            <v-list-item-title>Take Mock Test</v-list-item-title>
                          </v-list-item>
                          <v-list-item @click="downloadQuestions(assessment)" style="cursor: pointer;" :disabled="!$store.state.role.assessment.read">
                            <v-list-item-title>Download Questions</v-list-item-title>
                          </v-list-item>
                          <v-list-item @click="triggerAssessmentSoftDelete(assessment)"  style="cursor: pointer;" v-if="![2].includes(currentSelectedAssessmentStatus)" :class="$store.state.role.assessment.delete ? 'error--text':''" :disabled="!$store.state.role.assessment.delete">
                            <v-list-item-title>Delete</v-list-item-title>
                          </v-list-item>
                        </v-list>
                      </v-menu>
                    </div>
                  </template>
                </div>
                
                <v-container>
                  <v-row>
                    <v-col class="pl-0 py-1 pr-1" cols="3">
                      <span class="text-body-2">Language :</span>
                    </v-col>
                    <v-col cols="9" class="pa-1">
                      <span class='text-body-2' v-for="(item, index) in assessment.availableLanguages" :key="index">
                        {{ item }}<span v-if="index < assessment.availableLanguages.length - 1">, </span>
                      </span>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col class="pl-0 py-1 pr-1" cols="3">
                      <span class="text-body-2">Skills :</span>
                    </v-col>
                    <v-col cols="9" class="pa-1">
                      <span class='text-body-2'>{{ Array.isArray(assessment.skills) ? assessment.skills?.join(", ") : assessment.skills }}</span>
                      <template v-if="assessment.sections && assessment.sections.length">
                         <span class='text-body-2'> ({{ assessment.sections.map(s => s.name).join(", ") }})</span>
                      </template>
                      <template v-else>
                        No sections available

                      </template>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col class="pl-0 py-1 pr-1" cols="3">
                      <span class="text-body-2">Duration :</span>
                    </v-col>
                    <v-col cols="9" class="pa-1">
                      <span class='text-body-2'>{{assessment.duration }} mins</span>
                    </v-col>
                  </v-row>
                  <v-row v-if="currentSelectedAssessmentStatus == 2">
                    <v-col class="pl-0 py-1 pr-1" cols="3">
                      <span class="text-body-2">Campaigns -</span>
                    </v-col>
                    <v-col cols="9" class="pa-1">
                      <v-tooltip bottom style="z-index: 999">
                        <template v-slot:activator="{ on, attrs }">
                          <span class='text-body-2 font-weight-bold' v-bind="attrs" v-on="on">
                            {{assessment?.linkedCampaign?.length ?`${assessment?.linkedCampaign?.length}`:'0'}}
                          </span>
                        </template>
                        <span>{{ assessment?.linkedCampaign?.length ? assessment.linkedCampaign.join(', ') : 'Not Linked to any Campaign' }}</span>
                      </v-tooltip>
                    </v-col>
                  </v-row>
                </v-container>
                
                <v-spacer></v-spacer>
                
                <v-container class="gray-02 mt-auto rounded-lg">
                  <v-row class="d-flex align-center justify-space-between text-no-wrap pa-1">
                    <v-col class="d-flex align-center justify-start" cols="9">
                      <span class="text-body-2">Total Questions :</span>&nbsp;<span class="text-body-2">{{assessment?.totalQuestionsUploaded || 0}}</span>
                    </v-col>
                    <v-col class="d-flex align-center justify-end" cols="3">
                      <span class="text-body-2 ml-2">Marks :</span>&nbsp;<span class="text-body-2">{{assessment?.marksAllotted || 0}}</span>
                    </v-col>
                  </v-row>
                </v-container>
              </v-card>
            </v-col>
          </v-row>
          <!-- Shown once loading finishes with nothing to list — a search or
               filter that matched nothing, or a tab with no assessments at all.
               Mirrors the campaigns list empty state. -->
          <p v-else class="d-flex align-center justify-center h-100">No matching assessment found</p>
        </v-container>
      </div>

    </div>

  
    <v-dialog
      
      v-model="reportedQuestionsDialog" 
      fullscreen 
      hide-overlay
      class="settings-dialog-content">
      <v-card>
        <!-- Reported Questions Component -->
        <div fluid class="px-6 static-assessment-popup-container">
      <h3 class="pt-4 test">View Reported Questions</h3>
        <div class="d-flex align-center mb-4">
            <div class="flex-grow-1">
                <div class="text-h6 pr-1 ml-auto"></div>
            </div>
            <div
          class=" mx-0 d-flex align-center justify-end"
          >
          <v-card width="326px" class="elevation-0 transparent">
            <v-text-field
              solo
              label="Search here..."
              hide-details
              prepend-inner-icon="mdi-magnify"
              v-model="search"
              class="search-bar search-bar2 border-button rounded-pill mx-2"
              dense
              clearable
            ></v-text-field>
          </v-card>
           <v-btn
            class="btn outline-btn mx-2"
            outlined
            rounded
            @click="downloadReportedQuestions"
            ><v-icon>mdi-import mdi-rotate-90</v-icon></v-btn
          >
          <v-btn
            @click="questionsFilterDialog = true"
            dense
            rounded
            class="btn outline-btn elevation-0 mx-2 pl-4 pr-6"
            ><v-icon class="pr-2">mdi-tune</v-icon>
            
            <span>Filter</span>
          </v-btn>  
            </div>
        </div>
        <div>
        <v-data-table
  :headers="headers"
  :items="questions"
  :loading="isLoading"
  fixed-header
  height="calc(100vh - 224px)"
  class="rounded-table"
  header-class="custom-header"
  :options.sync="questionsOptions"
  :server-items-length="reportedQuestionCount"
  :items-per-page="questionsOptions.itemsPerPage"
  :page.sync="questionsOptions.page"
  hide-default-footer
>
  <template v-slot:loading>
    <bubble-loader />
  </template>

  <template v-slot:no-data>
    <div class="custom-no-data" style="height: 160px;">
      <p>No Data Available</p>
    </div>
  </template>

  <template v-slot:[`item.questionId`]="{ item }">
    {{ item.questionId }}
  </template>
  <template v-slot:[`item.questionStatement`]="{ item }">
    <div v-html="item.questionStatement"></div>
  </template>
  
  <template v-slot:[`item.assessmentName`]="{ item }">
    {{ item.assessmentName }}
  </template>

  <template v-slot:[`item.campaignName`]="{ item }">
    {{ item.campaignName }}
  </template>
  <template v-slot:footer="{ props }">
    <table-footer
      :pagination="props.pagination"
      :options="props.options"
      @update-options="onFooterUpdate"
    />
  </template>
</v-data-table>
      <div   class="mt-2 d-flex align-center justify-end">
        <v-btn
            @click="reportedQuestionsDialog = false"
            dense
            rounded
            class="btn outline-btn elevation-0 mx-2 pl-4 pr-6"
            >
            <span>CLOSE</span>
          </v-btn>  
      </div>
        
        </div>
    </div>
      </v-card>
    </v-dialog>
    
      <v-dialog v-model="questionsFilterDialog" class="cdz" max-width="570px">
          <v-card width="570px" height="100vh" class="filterDialogClass">
            <v-row class="mt-4 mx-1">
              <v-col>
                <div class="pl-0 mb-2 text-body1 font-weight-bold grey--text">
                  Filter
                </div>
              </v-col>
              <v-col class="d-flex justify-end">
                <div @click="clearQuestionFilter" class="clear-filter-btn">
                  CLEAR FILTER
                </div>
              </v-col>
            </v-row>

            <v-tabs vertical>
              <div class="ml-3 mt-4 mr-4 filterLine">
                <v-tab class="black--text justify-start" active-class="activeTab">
                  <span>Question Type</span>
                  <span v-if="selectedQuestionTypeFilter.length > 0" class="ml-1">({{ selectedQuestionTypeFilter.length
                    }})</span></v-tab>

                <v-tab class="black--text justify-start" active-class="activeTab">
                  <span>Level</span>
                  <span v-if="selectedQuestionLevelFilter.length > 0" class="ml-1">({{ selectedQuestionLevelFilter.length
                    }})</span></v-tab>

                <v-tab class="black--text justify-start" active-class="activeTab">
                  <span>Grade</span>
                <span v-if="selectedQuestionGradeFilter.length > 0" class="ml-1">({{ selectedQuestionGradeFilter.length
                  }})</span></v-tab>
                
                
                <v-tab class="black--text justify-start" active-class="activeTab">
                  <span>Skills</span>
                  <span v-if="selectedQuestionSkillFilter.length > 0" class="ml-1">({{ selectedQuestionSkillFilter.length
                    }})</span></v-tab>

                <v-tab class="black--text justify-start" active-class="activeTab">
                  <span>Campaign</span>
                  <span v-if="selectedCampaignFilter.length > 0" class="ml-1">({{ selectedCampaignFilter.length
                    }})</span></v-tab>
                
                <v-tab class="black--text justify-start" active-class="activeTab">
                  <span>Assessment</span>
                  <span v-if="selectedAssessmentFilter.length>0" class="ml-1">({{selectedAssessmentFilter.length}})</span>
                </v-tab>
                
              
                <v-tab class="black--text justify-start" active-class="activeTab">
                  <span>Reported Questions</span>
                  <span v-if="selectedReportedQuestionsFilter" class="ml-1">(1)</span></v-tab>


              </div>

              <v-tab-item>
                <v-card flat height="580px" id="myScroll">
                  <v-card-text>
                    <v-chip-group v-model="selectedQuestionTypeFilter" active-class="active-chip" column :multiple="true">
                      <v-chip v-for="(questionType, index) in filterQuestionTypeList" :key="index" :value="questionType"
                        elevated>
                      {{questionType.replace(/_/g, ' ')}}
                      </v-chip>
                    </v-chip-group>
                  </v-card-text>
                </v-card>
              </v-tab-item>

              <v-tab-item>
                <v-card flat height="580px" id="myScroll">
                  <v-card-text>
                    <v-chip-group v-model="selectedQuestionLevelFilter" active-class="active-chip" column :multiple="true">
                      <v-chip v-for="(level, index) in filterLevels" :key="index" :value="level" elevated>
                        {{ level }}
                      </v-chip>
                    </v-chip-group>
                  </v-card-text>
                </v-card>
              </v-tab-item>

              <v-tab-item>
                <v-card flat height="580px" id="myScroll">
                  <v-card
                v-if="selectedQuestionLevelFilter.length > 0"
                class="school-filter"
              >
                  <v-card-text>
                    <v-chip-group v-model="selectedQuestionGradeFilter" active-class="active-chip" column :multiple="true">
                      <v-chip v-for="(grade, index) in filterGrades" :key="index" :value="grade" elevated>
                        {{ grade }}
                      </v-chip>
                    </v-chip-group>
                  </v-card-text>
                </v-card>
                <v-card
                elevation="0"
                v-if="selectedQuestionLevelFilter.length == 0"
                class="school-filter"
              >
                <v-card-text class="d-flex justify-center">
                  Please Select Level First
                </v-card-text>
                </v-card>
                </v-card>
              </v-tab-item>

            
              <v-tab-item>
                <v-card flat height="580px" id="myScroll">
                  <v-card-text>
                    <v-chip-group v-model="selectedQuestionSkillFilter" active-class="active-chip" column :multiple="true">
                      <v-chip v-for="(skill, index) in filterSkills" :key="index" :value="skill" elevated>
                        {{ skill }}
                      </v-chip>
                    </v-chip-group>
                  </v-card-text>
                </v-card>
              </v-tab-item>

              
              <v-tab-item>
                <v-card flat height="580px" id="myScroll">
                  <v-card-text>
                    <v-chip-group v-model="selectedCampaignFilter" active-class="active-chip" column :multiple="true">
                      <v-chip v-for="(campaign, index) in filterCampaigns" :key="index" :value="campaign" elevated>
                        {{ campaign }}
                      </v-chip>
                    </v-chip-group>
                  </v-card-text>
                </v-card>
              </v-tab-item>

              <v-tab-item>
                <v-card flat height="580px" id="myScroll">
                  <v-card-text>
                    <v-chip-group v-model="selectedAssessmentFilter" active-class="active-chip" column :multiple="true">
                      <v-chip v-for="(assessment, index) in filterQuestionsAssessments" :key="index" :value="assessment" elevated>
                        {{ assessment }}
                      </v-chip>
                    </v-chip-group>
                  </v-card-text>
                </v-card>
              </v-tab-item>


              <v-tab-item>
                <v-card flat height="580px" id="myScroll">
                  <v-card-text>
                    <v-chip-group v-model="selectedReportedQuestionsFilter" active-class="active-chip" column
                      :multiple="false"
                      >

                      <v-chip v-for="(question, index) in creationDateAndTimeOptions" :key="index" :value="question.value" elevated>
                      {{ question.label }}
                    </v-chip>
                    <v-menu v-model="questionMenu" :close-on-content-click="false" transition="scale-transition" offset-y content-class="custom-z-menu">
                    <template v-slot:activator="{ on, attrs }">
                    <v-chip v-bind="attrs" v-on="on" elevated active-class="active-chip">
                    Custom Dates
                </v-chip>
            </template>
            <v-card>
              <v-card-title>Select Dates</v-card-title>
              <v-card-text>
                <v-row>
                  <v-col>
                    <v-menu ref="questionMenu" v-model="questionMenuStart" :close-on-content-click="false" transition="scale-transition" offset-y min-width="auto" content-class="custom-start-menu">
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field  class ="custom-date-picker"   v-bind="attrs" v-on="on" label="Start Date" prepend-icon="mdi-calendar" v-model="customReportedStartDate" readonly ></v-text-field>
                      </template>
                      <v-date-picker v-model="customReportedStartDate" @input="questionMenuStart = false" class="custom-date-picker"></v-date-picker>
                    </v-menu>
                  </v-col>
                  <v-col>
                    <v-menu ref="questionMenu" v-model="questionMenuEnd" :close-on-content-click="false" transition="scale-transition" offset-y min-width="auto" content-class="custom-end-menu">
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field  class ="custom-date-picker"  v-bind="attrs" v-on="on" label="End Date" prepend-icon="mdi-calendar" v-model="customReportedEndDate" readonly></v-text-field>
                      </template>
                      <v-date-picker v-model="customReportedEndDate" @input="questionMenuEnd = false" class="custom-date-picker"></v-date-picker>
                    </v-menu>
                  </v-col>
                </v-row>
              </v-card-text>
              <v-card-actions>
                <v-btn class="btn primary-btn" @click="addCustomQuestionDates">Ok</v-btn>
              </v-card-actions>
            </v-card>
          </v-menu>
                    </v-chip-group>
                  </v-card-text>
                </v-card>
              </v-tab-item>
            </v-tabs>

            <div class="filterDialogButton">
              <v-card-actions class="px-6 pb-3">
                <v-spacer></v-spacer>
                <v-btn rounded depressed class="btn outline-btn font-weight-medium pa-4"
                  @click="questionsFilterDialog = false">Cancel</v-btn>
                <v-btn rounded class="btn primary-btn pa-4" @click="

                  (questionsFilterDialog = false),
                  filterQuestions(),
                  getFilterCount()
                  ">Apply</v-btn>
              </v-card-actions>
            </div>
          </v-card>
        </v-dialog>



    <v-dialog
      v-model="loader"
      hide-overlay
      persistent
      width="300"
    >
      <v-card
        color="primary"
        dark
        :elevation="20"
      >
           <bubble-loader/>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>

  import "../styles.css";
  import { validationMixin } from "vuelidate";
  import { required, email } from "vuelidate/lib/validators";
  import StaticAssessmentController from "@/controllers/StaticAssessmentController";
  import GradeController from "@/controllers/GradeController";
  import AuthService from "../services/AuthService";
  import Notification from "./Notification";
  import { debounce } from "lodash";
  import Papa from "papaparse";
  import { format, startOfToday, startOfYesterday, startOfWeek, startOfMonth, endOfToday, endOfYesterday, endOfWeek, endOfMonth } from 'date-fns';
import BubbleLoader from '@/components/BubbleLoader.vue';
import UserNavMenu from "@/components/UserNavMenu.vue";
import ReportedQuestions from "@/components/ReportedQuestionsView.vue";
import AssessmentController from '@/controllers/AssessmentController';

  export default {
    mixins: [validationMixin],

    validations: {
      email: { required, email },
    },
    name: "StaticAssessmentView",
    components: {
      Notification,
      BubbleLoader,
      UserNavMenu,
      ReportedQuestions,
    },
    data() {
      return {
        rules: {
          required: (value) => !!value || "Field is required",
        },
        loader:false,
        loadingAssessmentsToDownload: false,
        selectedGradeFilter: [],
        selectedLanguageFilter:[],
        selectedSubjectFilter: [],
        selectedSkillFilter:[],
        selectedLevelFilter:[],
        selectedTimerFilter:[],
        selectedUserFilter:[],
        selectedCategoryFilter:[],
        selectedSectionFilter:[],
        selectedCreationDateAndTimeFilter: null,
        gradeOptions: [],
        languageOptions: [],
        subjectOptions: [],
        creationDateAndTimeOptions: [
          { label: 'Today', value: 'today' },
          { label: 'Yesterday', value: 'yesterday' },
          { label: 'This Week', value: 'this_week' },
          { label: 'Last Week', value: 'last_week' },
          { label: 'This Month', value: 'this_month' },
          { label: 'Last Month', value: 'last_month' },
        ],
        filterLoader: false,
        currentSelectedAssessmentStatus: this.getStatusFromRoute(),
        e1: 1,
        showUsers: false,
        notCleared: [],
        name: "",
        screeningMainsUser: "true",
        filterDialog: false,
        filterCount: 0,
        assessments: [],
        preloader: true,
        assessmentLoader: false,
        assessmentCounts: {},
        updateAssessmentDialog: false,
        updateAssessmentDialogLoading: false,
        deleteAssessmentDialog: false,
        deleteAssessmentDialogLoading: false,
        deleteSuccessDialog: false,
        editorConfig: {
        extraPlugins: "ckeditor_wiris",
        },
        assessmentDescription: "",
        assessmentName: "",
        // ckeditorError: false,
        currentSelectedAssessment: {},
        searchValue: this.$route.query.search || "",
        debouncedSearch: null,
        menu: false,
        menuStart: false,
        menuEnd: false,
        customStartDate: null,
        customEndDate: null,
        isCustomDate :false,
        isQuestionCustomDate: false,
        sendSelectedAssessmentsFilterRange: {},
        skillOptions:[],
        categoryOptions:[],
        userTypeOptions:[],
        timerTypeOptions:[],
        levelOptions:[],
        gradeOptions:[],
        sectionOptions:[],
        preloader :false,
        search: "",
        filterDialog:false,
        headers: [
        { text: "Question ID", value: "questionId", cellClass: "w-15", sortable: false  },
        { text: "Question", value: "questionStatement", cellClass: "w-30 text-lowercase", sortable: false  },
        { text: "Type", value: "type", cellClass: "w-15", sortable: false  },
        { text: "Assessment", value: "assessmentName", cellClass: "w-20", sortable: false},
        {
          text: "Campaign",
          value: "campaignName",
          cellClass: "w-20 text-left",
          sortable: false,
        },
        ],
        singleSelect: false,
        selected: [],
        questions:[],
        options: {},
        isLoading:false,
        count: 0,
        search: this.$route.query.search || "",
        reportedQuestionsDialog:false,
        debouncedQuestionSearch:null,
        questionsFilterDialog:false,
        filterQuestionTypeList:[],
        filterLevels:[],
        filterGrades:[],
        filterSkills:[],
        filterQuestionsAssessments:[],
        filterCampaigns:[],

        selectedQuestionGradeFilter: [],
        selectedQuestionLevelFilter:[],
        selectedQuestionSkillFilter: [],
        selectedAssessmentFilter:[],
        selectedCampaignFilter:[],
        selectedQuestionTypeFilter:[],
        selectedReportedQuestionsFilter:null,
        customReportedEndDate:null,
        customReportedStartDate:null,
        sendSelectedQuestionFilterRange:{},
        questionMenu:false,
        questionMenuStart: false,
        questionMenuEnd: false,
        filterQuestionLoader:false,
        questionsOptions: {
          page: 1,
          itemsPerPage: 10,
        },
        reportedQuestionCount:0,
      
      };
    },

    watch: {
      searchValue(value) {
        this.handleSearchChange(value);
      },
      search(newValue){
        console.log('value',newValue)
       const urlParams = new URLSearchParams(window.location.hash.split('?')[1] || '');
      const currentTab = urlParams.get('tab') || 'all';
      
      // Update URL with tab first, then search
      const baseUrl = window.location.origin + '/#/static-assessment';
      const tabParam = `tab=${currentTab}`;
      const searchParam = newValue ? `search=${encodeURIComponent(newValue)}` : '';
      const params = [tabParam, searchParam].filter(Boolean).join('&');
      const url = params ? `${baseUrl}?${params}` : baseUrl;
      window.history.pushState({}, '', url);

      if (this.search == null) {
        this.search = "";
      }
      this.questionsOptions.page = 1;
        this.debouncedQuestionSearch();
      },
      selectedCategoryFilter(newVal) {
    if (!newVal || newVal.length === 0) {
      this.levelOptions = [];
      this.sectionOptions = [];
      this.gradeOptions = [];
      return;
    }

    // Aggregate all levels, sections, grades from selected categories
    const levels = new Set();
    const sections = new Set();
    const grades = new Set();

    newVal.forEach(cat => {
      const details = this.categoryOptions[cat];
      if (details) {
        (details.levels || []).forEach(l => levels.add(l));
        (details.sections || []).forEach(s => sections.add(s));
        (details.grades || []).forEach(g => grades.add(g));
      }
    });

    this.levelOptions = Array.from(levels);
    this.sectionOptions = Array.from(sections);
    this.gradeOptions = Array.from(grades);
  }

      // currentSelectedAssessmentStatus() {
      //   this.updateUrlParams();
      // }
    },

    methods: {
      async getQuestionsFilters() {
        console.log('questions zcnvnv')
      const docId = 'questionFeedback';
        try {
            const response = await StaticAssessmentController.getMasterFilters(docId);
            this.filterQuestionTypeList = response.data.questionType;
            this.filterLevels = response.data.level
            this.filterGrades = response.data.grade
            this.filterSkills = response.data.skills
            this.filterQuestionsAssessments = response.data.assessment
            this.filterCampaigns = response.data.campaign
            console.log('this.filterCampaigns',this.filterCampaigns)
        } catch (error) {
            return error.response;
        }
      },
      showReportedQuestions(){
        this.getReportedQuestions();
        this.getQuestionsFilters();
        this.reportedQuestionsDialog = true;
      },
      async onFooterUpdate(newOptions) {
        Object.assign(this.questionsOptions, newOptions);
        await this.$nextTick();
        this.getReportedQuestions();
      },
      async getReportedQuestions(){
        try {
          if (!this.isQuestionCustomDate) {
            this.getQuestionDateRange();
          }
          this.isLoading = true;
          let filterDateRange = {};
        if(this.sendSelectedQuestionFilterRange?.end != "" && this.sendSelectedQuestionFilterRange?.start != "") {
          filterDateRange = JSON.stringify(this.sendSelectedQuestionFilterRange);
        };
        // var data = {};
        // data.page = this.page;
        // data.sortCol = this.sortCol;
        // data.sortOrder = this.sortOrder;
        // data.itemsPerPage = this.pageSize;
          const response = await AssessmentController.getReportedQuestions(this.questionsOptions.page, this.questionsOptions.itemsPerPage, this.search, btoa(this.selectedQuestionGradeFilter), btoa(this.selectedAssessmentFilter), btoa(this.selectedCampaignFilter), btoa(this.selectedQuestionSkillFilter),btoa(this.selectedQuestionLevelFilter),btoa(this.selectedQuestionTypeFilter),filterDateRange);
          if(response.status == 200){
            if (response.data.questions.length > 0) {
              this.questions = response.data.questions;
              this.reportedQuestionCount = response.data.count;
              
            }else{
              
              this.questions = []
            }
            this.filterLoader = false;
            this.preloader = false;
            this.assessmentLoader = false;
            this.isLoading = false;
            
          }else{
            alert(response.data.error);
            this.preloader = false;
            this.assessmentLoader = false;
          }
          // if(searchedValue) {
          //   this.$nextTick(() => {
          //     this.$refs.searchField.focus();
          //   });
          // }
        } catch (error) {
          console.error(error);
          this.isLoading = false;
        }
      },

      async fetchAssessment(status, searchedValue = false) {
        // Update localStorage when changing tabs
        const statusMap = {
          'PUBLISHED': 0,
          'DRAFT': 1,
          'LIVE': 2
        };
        
        this.currentSelectedAssessmentStatus = statusMap[status];
        this.updateUrlParams();
        
        // this.preloader = true;
        if (!this.isCustomDate) {
          this.getDateRange();
        }
        this.assessmentLoader = true;
        let filterDateRange = {};
        if(this.sendSelectedAssessmentsFilterRange?.end != "" && this.sendSelectedAssessmentsFilterRange?.start != "") {
          filterDateRange = JSON.stringify(this.sendSelectedAssessmentsFilterRange);
        };
        console.log('filterDateRange--------------------',filterDateRange)
        const response = await StaticAssessmentController.getStaticAssessments(status, this.searchValue, btoa(this.selectedGradeFilter), btoa(this.selectedSubjectFilter), btoa(this.selectedLanguageFilter), btoa(this.selectedSkillFilter),btoa(this.selectedLevelFilter),btoa(this.selectedTimerFilter),btoa(this.selectedUserFilter),btoa(this.selectedCategoryFilter),btoa(this.selectedSectionFilter),filterDateRange);
        if (response.status == 200) {
          if (response.data.assessments.length > 0) {
            this.assessments = response.data.assessments;
          } else {
            this.assessments = [];
          }
          // this.setFilterParams();

          this.filterLoader = false;
          this.preloader = false;
          this.assessmentLoader = false;
        } else {
          alert(response.data.error);
          this.preloader = false;
          this.assessmentLoader = false;
        }
        if(searchedValue) {
          this.$nextTick(() => {
            this.$refs.searchField.focus();
          });
        }
      },

      downloadReportedQuestions(){
        const questionsToExport = this.questions.slice().sort((a, b) => {
          return a.questionId.localeCompare(b.questionId);
});

        // console.log("questionsToExport====>", questionsToExport);
        
        const fileName = "questions.csv";
        const dataForDownload = [];
        const questionCount = {};
        let serialNo = 1;
        console.log('questionsToExport',questionsToExport)
        for (const val of questionsToExport) {
            val.questionStatement = val.questionStatement.replace(/<\/?[^>]+(>|$)/g, "");

            if (questionCount[val.questionId]) {
                questionCount[val.questionId].noOfUserReportedQuestion += 1;

                const obj = {
                    serialNo: serialNo++,
                    questionId: val.questionId,
                    testRound: '',
                    level: '',
                    grade: '',
                    skill: '',
                    questionStatement: '',
                };

                if (Array.isArray(val.questionOptions)) {
                    val.questionOptions.forEach((option, index) => {
                        obj[`optionValue${index + 1}`] = "";
                        obj[`optionKey${index + 1}`] = "";
                        obj[`optionScore${index + 1}`] = "";
                    });
                }

                Object.assign(obj, {
                    noOfUserReportedQuestion: '',
                    nameOfUser: val.nameOfUser,
                    campaignName: val.campaignName,
                    assessmentName: val.assessmentName,
                    reportedComment: val.reportedComment,
                    dateReported: this.normalizeDate(val.dateReported),
                    correctAnswer: val.correctAnswer,
                    
                });

                questionCount[`${val.questionId}-${questionCount[val.questionId].noOfUserReportedQuestion}`] = obj;
            } else {
                questionCount[val.questionId] = {
                    serialNo: serialNo++,
                    questionId: val.questionId,
                    testRound: val.testRound,
                    level: val.level,
                    grade: val.grade,
                    skill: val.skill,
                    questionStatement: val.questionStatement.replace(/<\/?[^>]+(>|$)/g, ""),
                };

                if (Array.isArray(val.questionOptions)) {
                    val.questionOptions.forEach((option, index) => {
                        questionCount[val.questionId][`optionValue${index + 1}`] = option.optionValue
                            ? option.optionValue.replace(/<\/?[^>]+(>|$)/g, "")
                            : "";
                        questionCount[val.questionId][`optionKey${index + 1}`] = option.optionKey || "";
                        questionCount[val.questionId][`optionScore${index + 1}`] = option.optionScore || "";
                    });
                }

                Object.assign(questionCount[val.questionId], {
                    noOfUserReportedQuestion: 1,
                    nameOfUser: val.nameOfUser,
                    campaignName: val.campaignName,
                    assessmentName: val.assessmentName,
                    reportedComment: val.reportedComment,
                    dateReported: this.normalizeDate(val.dateReported),
                  
                });
            }
        }

        for (const key in questionCount) {
            dataForDownload.push(questionCount[key]);
        }
        const sortedData = dataForDownload.slice().sort((a, b) => {
            return Number(a.serialNo) - Number(b.serialNo);
        });

        this.exportQuestions(sortedData, fileName);

      },
      normalizeDate(dateString) {
        console.log('mnmbbmnbm')
         return format(new Date(dateString), 'dd/MM/yyyy');
      },
      async exportQuestions(csvData, fileName) {
      const csv = Papa.unparse(csvData, {
        quotes: true,  // or array of booleans
        quoteChar: '"',
        escapeChar: '"'
      });

      const bom = '\uFEFF';
      const blob = new Blob([bom + csv], { type: "text/csv;charset=utf-8;" });
      if (navigator.msSaveBlob) {
        navigator.msSaveBlob(blob, fileName);
      } else {
        const link = document.createElement("a");
        if (link.download !== undefined) {
          const url = URL.createObjectURL(blob);
          link.setAttribute("href", url);
          link.setAttribute("download", fileName);
          link.style.visibility = "hidden";
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        }
      }
      this.loadingQuestionsToDownload = false;
    },
      async getMasterFilters() {
      const docId = 'staticAssessments';
        try {
          
            const response = await StaticAssessmentController.getMasterFilters(docId);
            this.subjectOptions = response.data.subject;
            this.languageOptions = response.data.language;
            this.skillOptions = response.data.skill;
            this.userTypeOptions = response.data.userType;
            this.timerTypeOptions = response.data.timerType;
            this.categoryOptions = response.data.categories;

          
        } catch (error) {
            return error.response;
        }
    },
      handleStartDateChange(date) {
        this.menuStart = false;
        if (this.customEndDate && date > this.customEndDate) {
          this.customEndDate = null;
        }
      },
      goToViewAssessment(assessment) {
        if(assessment.isQuestionUploaded == true){
          this.$router.push({
          path: "/view-static-assessment",
          query: { id: assessment.id ,status : assessment.status }
        });
        } 
      },
      addCustomDates() {
        this.isCustomDate = true;
        
        if (this.customStartDate && this.customEndDate) {
          this.sendSelectedAssessmentsFilterRange = {
            start: format(new Date(this.customStartDate), 'yyyy-MM-dd 00:00:00'),
            end: format(new Date(this.customEndDate), 'yyyy-MM-dd 23:59:59')
          };
          this.menu = false;
        }
      },
      addCustomQuestionDates() {
        this.isQuestionCustomDate = true;
        
        if (this.customReportedStartDate && this.customReportedEndDate) {
          this.sendSelectedQuestionFilterRange = {
            start: format(new Date(this.customReportedStartDate), 'yyyy-MM-dd 00:00:00'),
            end: format(new Date(this.customReportedEndDate), 'yyyy-MM-dd 23:59:59')
          };
          this.questionMenu = false;
        }
      },
      async getGrades() {
        const response = await GradeController.getAllGrades();
        if (response.status == 200) {
          if (response.data.grades.length > 0) {
            // this.gr = response.data.grades;
            this.gradeOptions = await response.data.grades.map((e) => e.name);
          if(this.filterLoader){
            this.filterDialog = true;
            this.filterLoader = false;
          }
          } else {
            this.gradeOptions = [];
          }
        } else {
          alert(response.data.error);
        }
      },
      async downloadCSV(csvData, fileName) {
        const csv = Papa.unparse(csvData);
        const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
        if (navigator.msSaveBlob) {
          navigator.msSaveBlob(blob, fileName);
        } else {
          const link = document.createElement("a");
          if (link.download !== undefined) {
            const url = URL.createObjectURL(blob);
            link.setAttribute("href", url);
            link.setAttribute("download", fileName);
            link.style.visibility = "hidden";
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
          }
        }
        this.loadingAssessmentsToDownload = false;
      },
      downloadAssessment() {
        this.loadingAssessmentsToDownload = true;
        const fileName = "assessments.csv";
        let csvData = this.assessments.map(({id, assessmentName, modeOfAssessment ,status, availableLanguages, createdOn, updatedOn, linkedCampaign })=>{
          return {
            "Assessment Id": id || 'NA',
            "Name":assessmentName || 'NA',
            "Mode of Assessment": modeOfAssessment || 'NA',
            "Status": status || 'NA',
            "Available Languages": this.convertArrayToCommaSepratedVals(availableLanguages) || 'NA',
            "Created On": this.formatDate(new Date(createdOn)) || 'NA',
            "Updated On": this.formatDate(new Date(updatedOn)) || 'NA',
            "Campaigns": linkedCampaign?.length ? linkedCampaign?.join(",") : ""
          }
        })
        this.downloadCSV(csvData, fileName);
      },
      convertArrayToCommaSepratedVals(data){
        return data.length ? data.join(", "): "NA"
      },
      formatDate(date) {
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0'); // getMonth is zero-based
        const day = String(date.getDate()).padStart(2, '0');
        const hours = String(date.getHours()).padStart(2, '0');
        const minutes = String(date.getMinutes()).padStart(2, '0');
        return `${day}/${month}/${year} ${hours}:${minutes}`;
      },
      openFilterDialog(){
        if(this.gradeOptions.length > 0 && this.subjectOptions.length > 0){
          this.filterLoader = false;
          this.filterDialog = true;
        }
      },
      closeFilter(){
        this.filterDialog = false;
      },
      clearFilter(){
        this.selectedGradeFilter = [];
        this.selectedSkillFilter = [];
        this.selectedCategoryFilter = [];
        this.selectedUserFilter = [];
        this.selectedTimerFilter = [];
        this.selectedSectionFilter = [];
        this.selectedLevelFilter = [];
        this.selectedSubjectFilter= [];
        this.selectedLanguageFilter = [];
        this.selectedCreationDateAndTimeFilter = null;
        this.getFilterCount();
        this.filterDialog = false;
        if (this.currentSelectedAssessmentStatus === 1) {
          this.fetchAssessment('DRAFT');
        } else if(this.currentSelectedAssessmentStatus === 0){
          this.fetchAssessment('PUBLISHED');
        } else {
          this.fetchAssessment('LIVE');
        }
        
      },
      clearQuestionFilter(){
        this.selectedQuestionGradeFilter = [];
        this.selectedQuestionSkillFilter = [];
        this.selectedQuestionLevelFilter = [];
        this.selectedQuestionTypeFilter = [];
        this.selectedAssessmentFilter = [];
        this.selectedCampaignFilter = [];
        this.selectedReportedQuestionsFilter = null;
        this.questionsFilterDialog = false;
        this.getQuestionFilterCount();
        this.getReportedQuestions();
      },
      filterQuestions(){
        this.filterQuestionLoader = true;
        this.getQuestionFilterCount();
        this.getReportedQuestions();
        this.filterQuestionLoader = false;
        this.questionsFilterDialog = false;
      },
      filterAssessments(){
        this.filterLoader = true;
        this.getFilterCount();
        if (this.currentSelectedAssessmentStatus === 1) {
          this.fetchAssessment('DRAFT');
        } else if(this.currentSelectedAssessmentStatus === 0){
          this.fetchAssessment('PUBLISHED');
        } else {
          this.fetchAssessment('LIVE');
        }
        this.filterLoader = false;
        this.filterDialog = false;
      },
      getQuestionFilterCount(){
        if (!this.isQuestionCustomDate) {
          this.getQuestionDateRange();
        }
        this.questionFilterCount = [
          this.selectedQuestionGradeFilter,
          this.selectedQuestionSkillFilter,
          this.selectedQuestionLevelFilter,
          this.selectedQuestionTypeFilter,
          this.selectedAssessmentFilter,
          this.selectedCampaignFilter,
          this.selectedCreationDateAndTimeFilter,
          this.selectedReportedQuestionsFilter
        ].filter(filter => filter?.length > 0).length;
      },
      getFilterCount(){
        if (!this.isCustomDate) {
          this.getDateRange();
        }
        this.filterCount = [
          this.selectedGradeFilter,
          this.selectedLanguageFilter,
          this.selectedSubjectFilter,
          this.selectedSkillFilter,
          this.selectedCategoryFilter,
          this.selectedUserFilter,
          this.selectedTimerFilter,
          this.selectedSectionFilter,
          this.selectedLevelFilter,
          this.selectedCreationDateAndTimeFilter
        ].filter(filter => filter?.length > 0).length;
      },
      goToAssessmentCreationForm() {
            this.$router.push({
                path: "/create-static-assessment",
                name: "CreateStaticAssessment", //use name for router push
            });
        },
      logout() {
        AuthService.logout();
        this.$router.push("/login");
      },

      triggerAssessmentSoftDelete(assessment) {
        this.currentSelectedAssessment = { ...assessment };
        this.deleteAssessmentDialog = true;
      },

      validateAssessmentUpdateForm() {
        // Validate the CKEditor field
        if (!this.assessmentDescription || this.assessmentDescription.trim() === '') {
          // this.ckeditorError = true;
        } else {
          // this.ckeditorError = false;
        }

        // If the form is valid, proceed with submission
        if (!this.$refs.updateForm.validate()) {
          return; // Stop submission if form is invalid
        }
        this.updateAssessmentDialogLoading = true;
        // Call the assessmentUpdate method if everything is valid
        this.assessmentUpdate();
      },

      onEditorReady(editor) {
        editor.on("afterCommandExec", function(event) {
          var commandName = event.data.name;
          if(['ckeditor_wiris_openFormulaEditor', 'ckeditor_wiris_openFormulaEditorChemistry'].includes(commandName) ) {
            setTimeout(() => {
                const wiris_license_overlays = document.querySelectorAll('.wrs_tickContainer')
                wiris_license_overlays.forEach(element => {
                  element.remove();
                });
              }, 2000)
          }
        })
      },
      clearSearch() {
        if (!this.$route.name || this.$route.name !== 'assessmentListingView') {
          this.searchValue = "";
          // localStorage.removeItem('assessmentSearchValue');
          // localStorage.removeItem('assessmentTabState');
        }
      },

      async assessmentUpdate() {
        if (this.$refs.updateForm.validate()) {
          const obj = {
            assessmentId: this.currentSelectedAssessment.id,
            assessmentName: this.currentSelectedAssessment.assessmentName,
            assessmentDescription: this.currentSelectedAssessment.assessmentDescription
          }
          const response = await StaticAssessmentController.updateStaticAssessment(obj);
          this.updateAssessmentDialogLoading = false;
          if(response.status) {
            this.updateAssessmentDialog = false;
            this.currentSelectedAssessmentStatus === 1 ? this.fetchAssessment('DRAFT') : this.fetchAssessment('PUBLISHED');
            this.fetchStaticAssessmentCounts();
          } else {
            this.updateAssessmentDialog = false;
          }
        } else {
          this.updateAssessmentDialog = false;
        }
      },

      editAssessmentName(assessment) {
        this.currentSelectedAssessment = { ...assessment };
        this.updateAssessmentDialog = true;
      },

      editAssessment(assessment) {
        if(assessment && assessment.id) {
          this.$router.push({ path: "/update-static-assessment", query: { id: assessment.id }});
        }
      },
      
      editAssessmentQuestions(assessment) {
        if(assessment && assessment.id) {
          this.$router.push({ path: "/static-assessment/edit", query: { id: assessment.id }});
        }
      },
      async downloadQuestions(assessment) {
        try {
          const response = await StaticAssessmentController.getStaticAssessmentsById(assessment.id);
          const assessmentData = response?.data?.assessments?.[0];
          const questions = assessmentData?.questions || [];

          if (questions.length === 0) {
            alert("No questions found for this assessment.");
            return;
          }

          const allQuestionsToExport = [];

          questions.forEach((question) => {
            if (question.QuestionDetails) {
              const { QuestionDetails, questionId, ...rest } = question;
              Object.keys(QuestionDetails).forEach((lang) => {
                const langDetails = QuestionDetails[lang];
                const options = langDetails.questionOptions || [];
                const flatQuestion = {
                  ...rest,
                  questionId,
                  languageOfQuestion: lang.charAt(0).toUpperCase() + lang.slice(1),
                  questionStatement: langDetails.questionStatement || "",
                  questionAssetUrl: langDetails.questionAssetUrl || "",
                  strand: langDetails.strand || rest.strand || "",
                  subStrand: langDetails.subStrand || rest.subStrand || "",
                  topic: langDetails.topic || rest.topic || "",
                  loCode1: langDetails.loCode1 || rest.loCode1 || "",
                  loCode2: langDetails.loCode2 || rest.loCode2 || "",
                  loCode3: langDetails.loCode3 || rest.loCode3 || "",
                  loCode4: langDetails.loCode4 || rest.loCode4 || "",
                  answerExplanation: langDetails.answerExplanation || rest.answerExplanation || "",
                  hint: langDetails.hint || rest.hint || "",
                  marksAllotted: rest.markingType === "Likert Marking" || rest.marksAllotted == null ? "NA" : rest.marksAllotted,
                };
                options.forEach((opt, idx) => {
                  flatQuestion[`optionKey${idx + 1}`] = opt.optionKey || "";
                  flatQuestion[`optionValue${idx + 1}`] = opt.optionValue || "";
                  flatQuestion[`optionScore${idx + 1}`] = opt.optionScore || "NA";
                });
                delete flatQuestion.QuestionDetails;
                delete flatQuestion.questionOptions;
                delete flatQuestion.mtfOptions;
                allQuestionsToExport.push(flatQuestion);
              });
            }
          });

          if (allQuestionsToExport.length === 0) return;

          const csvHeaders = [
            "questionId", "application", "skill", "setNumber", "level", "grade",
            "subject", "strand", "subStrand", "topic", "loCode1", "loCode2", "loCode3", "loCode4",
            "hrisUniqueRole", "markingType", "questionType", "languageOfQuestion",
            "questionStatement", "questionAssetUrl",
          ];

          let maxOptions = 0;
          allQuestionsToExport.forEach((q) => {
            let optIdx = 1;
            while (q[`optionKey${optIdx}`] !== undefined) optIdx++;
            if (optIdx - 1 > maxOptions) maxOptions = optIdx - 1;
          });

          for (let i = 1; i <= maxOptions; i++) {
            csvHeaders.push(`optionKey${i}`, `optionValue${i}`, `optionScore${i}`);
          }

          csvHeaders.push(
            "correctAnswer", "marksAllotted", "answerExplanation", "isCaseSensitive",
            "bloomsTaxonomy", "difficultyLevel", "complexityLevel",
            "proficiencyLevel", "hint", "authoredBy", "groupName"
          );

          const csvRows = [csvHeaders.join(",")];
          allQuestionsToExport.forEach((question) => {
            const row = csvHeaders.map((header) => {
              let value = question[header] ?? "NA";
              if (Array.isArray(value)) value = value.join(",");
              value = String(value);
              if (value.includes(",") || value.includes('"') || value.includes("\n")) {
                value = '"' + value.replace(/"/g, '""') + '"';
              }
              return value;
            });
            csvRows.push(row.join(","));
          });

          const csvContent = csvRows.join("\n");
          const blob = new Blob(["\uFEFF", csvContent], {
            type: "text/csv;charset=utf-8;",
          });
          const url = window.URL.createObjectURL(blob);
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", `${assessment.assessmentName || "assessment"}_questions.csv`);
          document.body.appendChild(link);
          link.click();
          link.parentNode.removeChild(link);
          window.URL.revokeObjectURL(url);
        } catch (error) {
          console.error("Error downloading questions:", error);
          alert("Failed to download questions. Please try again.");
        }
      },

      async deleteAssessment(documentId) {
        this.deleteAssessmentDialog = false;
        const response = await StaticAssessmentController.deleteStaticAssessmentById(documentId);
        if(response.status == 200) {
          this.currentSelectedAssessmentStatus === 1 ? this.fetchAssessment('DRAFT') : this.fetchAssessment('PUBLISHED');
          this.fetchStaticAssessmentCounts();
          this.deleteSuccessDialog = true;
        }
        else{
          alert(response.data.result);
        }
      },

      async initiateMockTest(assesmentId) {
        this.loader = true;
        const response = await StaticAssessmentController.getAccessToken(assesmentId);
        if(response.status === 200) {
          this.loader = false;
          window.open(`https://${this.$FRONTEND_DOMAIN}/#/staticassessment?token=${response.data.token}`,'_blank');
        } else {
          alert("Cann't authenticate to assessment server, Failed to start mock text");
          this.loader = false;
        }
      },

      formatTime(seconds) {
        const hours = Math.floor(seconds / 3600);
        const minutes = Math.floor((seconds % 3600) / 60);
        //const remainingSeconds = seconds % 60;
        if (hours == 0) {
          return String(minutes).padStart(2, "0") + " mins";
        } else {
          return (
            String(hours).padStart(2, "0") +
            " h and " +
            String(minutes).padStart(2, "0") +
            " mins"
          );
        }
      },
      async fetchAssessment(status, searchedValue = false) {
        // Update localStorage when changing tabs
        const statusMap = {
          'PUBLISHED': 0,
          'DRAFT': 1,
          'LIVE': 2
        };
        
        this.currentSelectedAssessmentStatus = statusMap[status];
        this.updateUrlParams();
        
        // this.preloader = true;
        if (!this.isCustomDate) {
          this.getDateRange();
        }
        this.assessmentLoader = true;
        let filterDateRange = {};
        if(this.sendSelectedAssessmentsFilterRange?.end != "" && this.sendSelectedAssessmentsFilterRange?.start != "") {
          filterDateRange = JSON.stringify(this.sendSelectedAssessmentsFilterRange);
        };
        
        const response = await StaticAssessmentController.getStaticAssessments(status, this.searchValue, btoa(this.selectedGradeFilter), btoa(this.selectedSubjectFilter), btoa(this.selectedLanguageFilter), btoa(this.selectedSkillFilter),btoa(this.selectedLevelFilter),btoa(this.selectedTimerFilter),btoa(this.selectedUserFilter),btoa(this.selectedCategoryFilter),btoa(this.selectedSectionFilter),filterDateRange);
        if (response.status == 200) {
          if (response.data.assessments.length > 0) {
            this.assessments = response.data.assessments;
          } else {
            this.assessments = [];
          }
          // this.setFilterParams();

          this.filterLoader = false;
          this.preloader = false;
          this.assessmentLoader = false;
        } else {
          alert(response.data.error);
          this.preloader = false;
          this.assessmentLoader = false;
        }
        if(searchedValue) {
          this.$nextTick(() => {
            this.$refs.searchField.focus();
          });
        }
      },

      setFilterParams(){
        this.gradeOptions = [...new Set(this.assessments.flatMap(({ grade }) => Array.isArray(grade) ? grade : [grade]))];
        this.subjectOptions = [...new Set(this.assessments.filter(({ subjects }) => subjects && !subjects.includes('NA')).flatMap(({ subjects }) => subjects))];
        this.languageOptions = [... new Set(...this.assessments.map(({availableLanguages})=>availableLanguages))];
      },

      async fetchStaticAssessmentCounts() {
        const response = await StaticAssessmentController.getStaticAssessmentCounts();
        if (response.status == 200) {
          if (response.data.counts) {
            this.assessmentCounts = response.data.counts;
          } else {
            this.assessmentCounts = {};
          }

          this.preloader = false;
        }
      },
      getDateRange() {
        switch (this.selectedCreationDateAndTimeFilter) {
          case 'today':
            this.sendSelectedAssessmentsFilterRange = {
              start: format(startOfToday(), 'yyyy-MM-dd 00:00:00'),
              end: format(endOfToday(), 'yyyy-MM-dd 23:59:59')
            };
            break;
          case 'yesterday':
            this.sendSelectedAssessmentsFilterRange = {
              start: format(startOfYesterday(), 'yyyy-MM-dd 00:00:00'),
              end: format(endOfYesterday(), 'yyyy-MM-dd 23:59:59')
            };
            break;
          case 'this_week':
            this.sendSelectedAssessmentsFilterRange = {
              start: format(startOfWeek(new Date(), { weekStartsOn: 1 }), 'yyyy-MM-dd 00:00:00'),
              end: format(endOfWeek(new Date(), { weekStartsOn: 1 }), 'yyyy-MM-dd 23:59:59')
            };
            break;
          case 'last_week':
            const lastWeekDate = new Date(new Date().setDate(new Date().getDate() - 7));
            this.sendSelectedAssessmentsFilterRange = {
            start: format(startOfWeek(lastWeekDate, { weekStartsOn: 1 }), 'yyyy-MM-dd 00:00:00'),
            end: format(endOfWeek(lastWeekDate, { weekStartsOn: 1 }), 'yyyy-MM-dd 23:59:59')
            };
            break;
          case 'this_month':
            this.sendSelectedAssessmentsFilterRange = {
              start: format(startOfMonth(new Date()), 'yyyy-MM-dd 00:00:00'),
              end: format(endOfMonth(new Date()), 'yyyy-MM-dd 23:59:59')
            };
            break;
          case 'last_month':
            const lastMonthDate = new Date(new Date().setMonth(new Date().getMonth() - 1));
            this.sendSelectedAssessmentsFilterRange = {
              start: format(startOfMonth(lastMonthDate), 'yyyy-MM-dd 00:00:00'),
              end: format(endOfMonth(lastMonthDate), 'yyyy-MM-dd 23:59:59')
            };
            break;
          default:
            this.sendSelectedAssessmentsFilterRange = {};
            break;
        }
      },
    getStatusFromRoute() {
      const status = this.$route.query.status;
      switch(status) {
        case 'PUBLISHED': return 0;
        case 'DRAFT': return 1;
        case 'LIVE': return 2;
        default: return 0; // Default to PUBLISHED
      }
    },

    getStatusString(statusValue) {
      switch(statusValue) {
        case 0: return 'PUBLISHED';
        case 1: return 'DRAFT';
        case 2: return 'LIVE';
        default: return 'PUBLISHED';
      }
    },

    updateUrlParams() {
      const query = {
        status: this.getStatusString(this.currentSelectedAssessmentStatus)
      };
      
      if (this.searchValue) {
        query.search = this.searchValue;
      }

      this.$router.replace({ 
        query: query 
      }).catch(() => {});
    },

    handleSearchChange(value) {
      // if (value === null) {
      //   this.searchValue = "";
      // }
      // localStorage.setItem('assessmentSearchValue', value);
      this.updateUrlParams();
      this.debouncedSearch();
    },
    handleQuestionSearchChange(nawValue){
        //  this.updateUrlParams();
        // Get current tab from URL
      
    },
    getQuestionDateRange() {
        switch (this.selectedReportedQuestionsFilter) {
          case 'today':
            this.sendSelectedQuestionFilterRange = {
              start: format(startOfToday(), 'yyyy-MM-dd 00:00:00'),
              end: format(endOfToday(), 'yyyy-MM-dd 23:59:59')
            };
            break;
          case 'yesterday':
            this.sendSelectedQuestionFilterRange = {
              start: format(startOfYesterday(), 'yyyy-MM-dd 00:00:00'),
              end: format(endOfYesterday(), 'yyyy-MM-dd 23:59:59')
            };
            break;
          case 'this_week':
            this.sendSelectedQuestionFilterRange = {
              start: format(startOfWeek(new Date(), { weekStartsOn: 1 }), 'yyyy-MM-dd 00:00:00'),
              end: format(endOfWeek(new Date(), { weekStartsOn: 1 }), 'yyyy-MM-dd 23:59:59')
            };
            break;
          case 'last_week':
            const lastWeekDate = new Date(new Date().setDate(new Date().getDate() - 7));
            this.sendSelectedQuestionFilterRange = {
            start: format(startOfWeek(lastWeekDate, { weekStartsOn: 1 }), 'yyyy-MM-dd 00:00:00'),
            end: format(endOfWeek(lastWeekDate, { weekStartsOn: 1 }), 'yyyy-MM-dd 23:59:59')
            };
            break;
          case 'this_month':
            this.sendSelectedQuestionFilterRange = {
              start: format(startOfMonth(new Date()), 'yyyy-MM-dd 00:00:00'),
              end: format(endOfMonth(new Date()), 'yyyy-MM-dd 23:59:59')
            };
            break;
          case 'last_month':
            const lastMonthDate = new Date(new Date().setMonth(new Date().getMonth() - 1));
            this.sendSelectedQuestionFilterRange = {
              start: format(startOfMonth(lastMonthDate), 'yyyy-MM-dd 00:00:00'),
              end: format(endOfMonth(lastMonthDate), 'yyyy-MM-dd 23:59:59')
            };
            break;
          default:
            this.sendSelectedQuestionFilterRange = {};
            break;
        }
      },
    },
    mounted() {
      this.getMasterFilters();
    this.$nextTick(() => {
      window.addEventListener("resize", this.onResize);
    });
    
  },
    created() {
      
      // Initialize with the stored tab state
      // const storedTabState = parseInt(localStorage.getItem('assessmentTabState'));
      const statusFromRoute = this.getStatusFromRoute();
      this.currentSelectedAssessmentStatus = statusFromRoute;
      
      const statusMap = {
        0: 'PUBLISHED',
        1: 'DRAFT',
        2: 'LIVE'
      };
      
      // this.currentSelectedAssessmentStatus = storedTabState || 0;
      this.fetchAssessment(statusMap[statusFromRoute] || 'PUBLISHED');
      this.fetchStaticAssessmentCounts();
      this.debouncedSearch = debounce(() => {
        if (this.currentSelectedAssessmentStatus === 1) {
          this.fetchAssessment('DRAFT', true);
        } else if(this.currentSelectedAssessmentStatus === 0){
          this.fetchAssessment('PUBLISHED', true);
        } else {
          this.fetchAssessment('LIVE', true);
        }
      }, 500);
      
      this.debouncedQuestionSearch = debounce(this.getReportedQuestions,500);
      this.$store.state.breadcrumb = "Assessment";
    },

    unmounted() {
      this.debouncedSearch.cancel();
      this.debouncedQuestionSearch.cancel();
    },

    beforeRouteLeave(to, from, next) {
      if (to.name !== 'assessmentListingView') {
        this.clearSearch();
      }
      next();
    },

    
    beforeDestroy() {
      window.removeEventListener("resize", this.onResize);
    },

    beforeRouteUpdate(to, from, next) {
      this.searchValue = to.query.search || "";
      const status = to.query.status || 'PUBLISHED';
      next();
    }
  };
</script>

<style scoped>
  .pad {
    padding-top: "80px";
  }
.menuable__content__active {
  z-index: 1034 !important;
  margin: 6px 0px 0px -10px;
  .v-picker {
    .v-picker__body {
      width: 218px !important   
    }
    .v-date-picker-title__date {
      font-size: 24px;
    }
    .v-date-picker-header .v-btn {
      height: 36px !important;
    }
    .v-date-picker-table--date .v-btn {
      height: 26px !important;
      width: 26px;
    }
    .v-date-picker-table {
      height: 190px;
    }
  }
}


.v-data-table thead tr th.text-start {
    background-color: #EBF2FF !important;
}

 

</style>
